export default "__VITE_ASSET__CYDH$j4R__"